import { render, staticRenderFns } from "./UiButton.vue?vue&type=template&id=290cbb19&scoped=true"
import script from "./UiButton.vue?vue&type=script&setup=true&lang=ts"
export * from "./UiButton.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./UiButton.vue?vue&type=style&index=0&id=290cbb19&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../../work/modules/node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "290cbb19",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {UiIcon: require('/storage/data/jenkins/workspace/WEBPLATFORM/FRONTEND/PRESTIGIO-SOLUTIONS/PRESTIGIO-SOLUTIONS_Deploy_Prod@4/components/ui/UiIcon.vue').default})
